// removed by extract-text-webpack-plugin
module.exports = {"smoke":"src-components-modules-Line-style----color-module---smoke---2WOUZ bg-smoke","steel":"src-components-modules-Line-style----color-module---steel---1sW9v bg-steel"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Line/style/color.module.css
// module id = 1486
// module chunks = 168707334958949